import React from 'react'
import { List, ListItem, ListItemText } from '@mui/material'
import CircleIcon from '@mui/icons-material/Circle'

const passwordRequirements = [
  'One lowercase character',
  'One uppercase character',
  'One number',
  'One special character',
  '8 characters minimum'
]

const PasswordRequirements = () => {
  return (
    <div>
      <List sx={{ pl: 2 }}>
        {passwordRequirements.map((requirement, index) => (
          <ListItem sx={{ paddingLeft: 0, paddingBottom: 0, paddingTop: 0 }} key={index}>
            <CircleIcon sx={{ marginRight: 1, width: '8px', color: '#8F989E' }} />
            <ListItemText sx={{ m: 0 }} primaryTypographyProps={{ style: { color: '#8F989E' } }} primary={requirement} />
          </ListItem>
        ))}
      </List>
    </div>
  )
}

export default PasswordRequirements
